import { Injectable } from '@angular/core';
import { GlobalAuthorityRequestResource } from '@app/shared/resources/global-authority-request-resource.service';
import { GlobalAuthorityRequest, Status } from '@app/shared/models/user-global-authority-request-interface';
import { Observable } from 'rxjs';
import { GlobalAuthority } from '@app/shared/models/global-authority';

@Injectable({
  providedIn: 'root'
})
export class GlobalAuthorityRequestService {
  constructor(private globalAuthorityRequestResource: GlobalAuthorityRequestResource) {}

  public getGlobalAuthorityRequestsByStatus(status: Status): Observable<GlobalAuthorityRequest[]> {
    return this.globalAuthorityRequestResource.getGlobalAuthorityRequestsByStatus(status);
  }

  public getAllRequestsByStatusAndManagingCompanyAndAuthority(managingCompanyId: number, status: Status, globalAuthority: GlobalAuthority): Observable<GlobalAuthorityRequest[]> {
    return this.globalAuthorityRequestResource.getAllRequestsByStatusAndManagingCompanyAndAuthority(managingCompanyId, status, globalAuthority);
  }

  public setGlobalAuthorityRequestStatus(id: number, fromStatus: Status, toStatus: Status): Observable<Status> {
    return this.globalAuthorityRequestResource.setGlobalAuthorityRequestStatus(id, fromStatus, toStatus);
  }

  public changeStatusWithManagingCompanyAuthority(id: number, managingCompanyId: number, fromStatus: Status, toStatus: Status): Observable<Status> {
    return this.globalAuthorityRequestResource.changeStatusWithManagingCompanyAuthority(id,managingCompanyId, fromStatus, toStatus);
  }
}
